import React from "react";
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import taskImage1 from "assets/img/ryan.jpg";
import taskImage2 from "assets/img/eva.jpg";

import taskRTLImage1 from "assets/img/emilyz.jpg";
import taskRTLImage2 from "assets/img/james.jpg";
import taskRTLImage3 from "assets/img/mike.jpg";
import { Switch } from 'antd';

// ##############################
// // // tasks list for Tasks card in Dashboard view
// #############################

const tasks = [
  {
    checked: true,
    image: taskImage1,
    text: 'Sign contract for "What are conference organizers afraid of?"'
  },
  {
    checked: false,
    image: taskImage1,
    text: "Lines From Great Russian Literature? Or E-mails From My Boss?"
  },
  {
    checked: true,
    image: taskImage2,
    text:
      "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
  }
];

// ##############################
// // // tasks list for Tasks card in RTL view
// #############################

const tasksRTL = [
  {
    checked: true,
    image: taskRTLImage1,
    text: 'توقيع عقد "ما يخشاه منظمو المؤتمر؟"	'
  },
  {
    checked: false,
    image: taskRTLImage2,
    text: "خطوط من الأدب الروسي العظيم؟ أو رسائل البريد الإلكتروني من بلدي بوس؟	"
  },
  {
    checked: true,
    image: taskRTLImage3,
    text:
      "مغمورة: بعد مرور عام ، تقييم ما فقد وما تم العثور عليه عندما اجتاحت الأمطار المدمرة مترو ديترويت	"
  }
];

// ##############################
// // // table head data and table body data for Tables view
// #############################

const thead = ["Fecha", "Devolución", "Cliente", "Factura", "Total", "Estado", "Acciones"];
const usershead = ["Activar", "Usuario", "Contrasena", "Cifrado", "Estado"];
const accessloghead = ["Tipo", "Fecha", "Evento"];
const loghead = ["Tipo", "Fecha", "Evento"];
// const theadhomevisits = ["Hora", "Localidad", "Tipo", "Título"];
const theadcontracts = ["Categoría", "Título", "Estado", "Acceso", "Acciones"];
const theadcontracttemplates = ["Título", "Acciones"];
const theadcustomers = [
  "Estado",
  "Creación",
  "Nombre",
  "Teléfono",
  "DNI",
  /*"Email",*/
  "Dirección",
  "Localidad",
  "Distribuidor"
];
const theadmobiles = [
  "Número",
  "Cliente",
  "DNI",
  "Tarifa",
  "Precio",
  /*"Gigas",
  "Minutos",*/
  "Consumo"
];
const theadmobileprocedures = [
  "Creación",
  "Cambio",
  "Autor",
  "Cliente",
  "Tipo",
  "Número",
  "Tarifa",
  "ICC",
  "Tipo Prev",
  "ICC Prev",
  "Estado"
];
const theadmobilebonuses = ["Bono", "Tipo", "Restante"];
const theadwebmobilerequests = [
  "Estado",
  "Fecha",
  "Trámite",
  "Red",
  "Tipo Cliente",
  "DNI/NIE/NIF",
  "Nombre",
  "Móvil",
  "Observaciones",
  "Acciones"
  // "DNI Frontal",
  // "DNI Trasera",
  // "Firma"
];
const theadwebmobilerequestsmini = [
  "Estado",
  "Fecha",
  "Red",
  "Contacto",
  "Trámite",
  "Móvil",
  "Observaciones",
  "Acciones"
  // "DNI Frontal",
  // "DNI Trasera",
  // "Firma"
];
const theadsimdeliveriesmini = [
  "Envío",
  "Entrega",
  "Red",
  "ICC",
  "Número",
  "Estado"
  // "DNI Frontal",
  // "DNI Trasera",
  // "Firma"
];
const theadhomevisits = [
  "Día",
  "Hora",
  "Título",
  "Tipo",
  "Estado",
  "Localidad"
  // "DNI Frontal",
  // "DNI Trasera",
  // "Firma"
];
const theadtickets = [
  "Prio.",
  "Referencia",
  "Concepto",
  "Departamento",
  "Estado",
  "Agente"
  // "DNI Frontal",
  // "DNI Trasera",
  // "Firma"
];
const theadcustomerscommunications = [
  "Fecha",
  "Tipo",
  "Título",
  "Ver"
  // "DNI Frontal",
  // "DNI Trasera",
  // "Firma"
];
const tbody = [
  {
    className: "table-success",
    data: ["Dakota Rice", "Niger", "Oud-Turnhout", "$36,738"]
  },
  {
    className: "",
    data: ["Minerva Hooper", "Curaçao", "Sinaai-Waas", "$23,789"]
  },
  {
    className: "table-info",
    data: ["Sage Rodriguez", "Netherlands", "Baileux", "$56,142"]
  },
  {
    className: "",
    data: ["Philip Chaney", "Korea, South", "Overland Park", "$38,735"]
  },
  {
    className: "table-danger",
    data: ["Doris Greene", "Malawi", "Feldkirchen in Kärnten", "$63,542"]
  },
  { className: "", data: ["Mason Porter", "Chile", "Gloucester", "$78,615"] },
  {
    className: "table-warning",
    data: ["Jon Porter", "Portugal", "Gloucester", "$98,615"]
  }
];
const usersbody = [
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'adrian@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'ingenieria@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'externo@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'rosa@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'juan.perez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'maria.garcia@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'carlos.lopez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'laura.martinez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'pedro.gonzalez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'sofia.rodriguez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'luis.fernandez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'ana.ruiz@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'fernando.morales@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'patricia.ramos@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'david.gimenez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'claudia.molina@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'francisco.sanchez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'natalia.diaz@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'alberto.mendez@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'jorge.ortega@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'elena.romero@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'ricardo.flores@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'marta.navarro@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'sergio.iglesias@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'beatriz.vera@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'andres.herrera@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'victoria.cortes@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'pablo.silva@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'monica.castro@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'isabel.vargas@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    },
    {
      className: 'table-success',
      data: [
        <Switch checked={true} />,
        'raul.santos@lloretproteccion.com',
        '********',
        'SSL/TLS',
        '24/02/2024 - 14:18',
        <span className="estado activo">Activo</span>
      ]
    }
  ];
  ;
const usersbodykooks =[
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'david.martinez@kooks.me',
      '********',
      'SSL/TLS',
      '24/02/2024 - 14:18',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'puchades.diaz@kooks.me',
      '********',
      'SSL/TLS',
      '16/02/2024 - 10:23',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'torro.calatayud@kooks.me',
      '********',
      'SSL/TLS',
      '21/02/2024 - 12:59',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'perez.gallego@kooks.me',
      '********',
      'SSL/TLS',
      '17/02/2024 - 13:42',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'marques.gines@kooks.me',
      '********',
      'SSL/TLS',
      '27/02/2024 - 10:14',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'florent.palomo@kooks.me',
      '********',
      'SSL/TLS',
      '05/03/2024 - 16:51',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'lopez.sanjose@kooks.me',
      '********',
      'SSL/TLS',
      '23/02/2024 - 17:10',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'gil.garcia@kooks.me',
      '********',
      'SSL/TLS',
      '23/02/2024 - 11:47',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-danger',
    data: [
      <Switch checked={false} />,
      'puchol.leiva@kooks.me',
      '********',
      'SSL/TLS',
      '03/03/2024 - 17:01',
      <span className="estado deshabilitado">Deshabilitado</span>
    ]
  },
  {
    className: 'table-danger',
    data: [
      <Switch checked={false} />,
      'jordan.ginez@kooks.me',
      '********',
      'SSL/TLS',
      '01/03/2024 - 17:16',
      <span className="estado deshabilitado">Deshabilitado</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'leon.roca@kooks.me',
      '********',
      'SSL/TLS',
      '01/03/2024 - 13:34',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'delatorre.palomo@kooks.me',
      '********',
      'SSL/TLS',
      '22/02/2024 - 15:21',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'escobar.asensio@kooks.me',
      '********',
      'SSL/TLS',
      '18/02/2024 - 14:43',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'quimiz.bautista@kooks.me',
      '********',
      'SSL/TLS',
      '29/02/2024 - 14:04',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'bodega.pozo@kooks.me',
      '********',
      'SSL/TLS',
      '28/02/2024 - 11:12',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'zambrano.sabater@kooks.me',
      '********',
      'SSL/TLS',
      '28/02/2024 - 14:18',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'aroca.dealfonso@kooks.me',
      '********',
      'SSL/TLS',
      '04/03/2024 - 15:13',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'edine.brisa@kooks.me',
      '********',
      'SSL/TLS',
      '02/03/2024 - 18:23',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'tecles.nieto@kooks.me',
      '********',
      'SSL/TLS',
      '01/03/2024 - 16:03',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'hernandez.cedelo@kooks.me',
      '********',
      'SSL/TLS',
      '17/02/2024 - 13:09',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'pastor.bonmati@kooks.me',
      '********',
      'SSL/TLS',
      '03/03/2024 - 12:55',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'medina.checa@kooks.me',
      '********',
      'SSL/TLS',
      '28/02/2024 - 15:35',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'sanchez.lopez@kooks.me',
      '********',
      'SSL/TLS',
      '02/03/2024 - 09:56',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'moudrik.esteban@kooks.me',
      '********',
      'SSL/TLS',
      '18/02/2024 - 12:32',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'carvallo.blasco@kooks.me',
      '********',
      'SSL/TLS',
      '03/03/2024 - 17:45',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'canela.bargues@kooks.me',
      '********',
      'SSL/TLS',
      '21/02/2024 - 13:02',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'gines.landete@kooks.me',
      '********',
      'SSL/TLS',
      '21/02/2024 - 11:31',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'garcia.delpuerto@kooks.me',
      '********',
      'SSL/TLS',
      '03/03/2024 - 16:33',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'vidal.gomez@kooks.me',
      '********',
      'SSL/TLS',
      '29/02/2024 - 17:55',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'campos.lopez@kooks.me',
      '********',
      'SSL/TLS',
      '27/02/2024 - 17:04',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'gimeno.ibañez@kooks.me',
      '********',
      'SSL/TLS',
      '04/03/2024 - 18:19',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'martinez.raimondo@kooks.me',
      '********',
      'SSL/TLS',
      '23/02/2024 - 16:29',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'calleja.gimeno@kooks.me',
      '********',
      'SSL/TLS',
      '22/02/2024 - 13:27',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'torres.sanchis@kooks.me',
      '********',
      'SSL/TLS',
      '20/02/2024 - 09:37',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'sanchez.rodriguez@kooks.me',
      '********',
      'SSL/TLS',
      '26/02/2024 - 16:08',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'palomar.nidaguila@kooks.me',
      '********',
      'SSL/TLS',
      '21/02/2024 - 11:55',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'ramon.landete@kooks.me',
      '********',
      'SSL/TLS',
      '03/03/2024 - 15:10',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'martinez.blasco@kooks.me',
      '********',
      'SSL/TLS',
      '03/03/2024 - 13:20',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'pastor.fayos@kooks.me',
      '********',
      'SSL/TLS',
      '25/02/2024 - 12:52',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'jimenez.soard@kooks.me',
      '********',
      'SSL/TLS',
      '01/03/2024 - 09:27',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'nacher.martinez@kooks.me',
      '********',
      'SSL/TLS',
      '21/02/2024 - 14:33',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'galindo.grande@kooks.me',
      '********',
      'SSL/TLS',
      '01/03/2024 - 10:35',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'lamwahi.miquel@kooks.me',
      '********',
      'SSL/TLS',
      '22/02/2024 - 16:58',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'aleixandre.espada@kooks.me',
      '********',
      'SSL/TLS',
      '02/03/2024 - 14:24',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'ballester.souto@kooks.me',
      '********',
      'SSL/TLS',
      '27/02/2024 - 12:12',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'lopez.exposito@kooks.me',
      '********',
      'SSL/TLS',
      '19/02/2024 - 09:21',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'martin.real@kooks.me',
      '********',
      'SSL/TLS',
      '27/02/2024 - 10:41',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-info',
    data: [
      <Switch checked={true} />,
      'sanchez.fambuena@kooks.me',
      '********',
      'SSL/TLS',
      '28/02/2024 - 16:23',
      <span className="estado activo">Activo</span>
    ]
  }
];
const usersbodymoier = [
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'claudia.villar@moier.co',
      '****',
      'SSL/TLS',
      '01/09/2023 - 07:15',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'teresa.arrebola@moier.co',
      '****',
      'SSL/TLS',
      '01/09/2023 - 07:21',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'ana.garcia@moier.co',
      '****',
      'SSL/TLS',
      '01/09/2023 - 08:01',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'francisco.garcia@moier.co',
      '****',
      'SSL/TLS',
      '01/09/2023 - 09:52',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'maria.garcia@moier.co',
      '****',
      'SSL/TLS',
      '01/09/2023 - 09:55',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'juan.gomez@moier.co',
      '****',
      'SSL/TLS',
      '06/09/2023 - 15:48',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'maria.gonzalez@moier.co',
      '****',
      'SSL/TLS',
      '07/09/2023 - 10:07',
      <span className="estado activo">Activo</span>
    ]
  },
  {
    className: 'table-danger',
    data: [
      <Switch checked={false} />,
      'laura.martinez@moier.co',
      '****',
      'SSL/TLS',
      '08/09/2023 - 15:38',
      <span className="estado deshabilitado">Deshabilitado</span>
    ]
  },
  {
    className: 'table-success',
    data: [
      <Switch checked={true} />,
      'jose.jimenez@moier.co',
      '****',
      'SSL/TLS',
      '',
      <span className="estado activo">Activo</span>
    ]
  },

  
];
const oldAccesslogbody =[
  {
    className: "",
    data: ["Normal", "27/11/2023 - 08:46", "Admin Moier (claudia.villar@moier.co) añadió la IP 185.237.180.0/24 al filtro por IP"]
  },
  {
    className: "",
    data: ["Normal", "27/11/2023 - 08:44", "Admin Moier (claudia.villar@moier.co) habilitó el filtrado por IP"]
  },
  {
    className: "",
    data: ["Normal", "27/11/2023 - 08:43", "Admin Moier (claudia.villar@moier.co) inició sesión desde la IP 88.1.158.9"]
  },
  {
    className: "",
    data: ["Normal", "05/09/2023 - 09:55", "Admin Moier (claudia.villar@moier.co) creó el usuario teresa.arrebola@moier.co"]
  },
  {
    className: "table-warning",
    data: ["Normal", "05/09/2023 - 19:57", "teresa.arrebola@moier.co intentó iniciar sesión contraseña incorrecta"]
  },
  {
    className: "",
    data: ["Normal", "05/09/2023 - 19:59", "teresa.arrebola@moier.co inició sesión correctamente"]
  },
  {
    className: "",
    data: ["Normal", "08/09/2023 - 10:51", "Admin Moier (claudia.villar@moier.co) creó el usuario ana.garcia@moier.co"]
  },
  {
    className: "",
    data: ["Alarma", "08/09/2023 - 10:55", "Admin Moier (claudia.villar@moier.co) creó el usuario francisco.garcia@moier.co"]
  },
  {
    className: "",
    data: ["Normal", "08/09/2023 - 11:06", "Admin Moier (claudia.villar@moier.co) creó el usuario maria.garcia@moier.co"]
  },
  {
    className: "",
    data: ["Normal", "08/09/2023 - 11:17", "Admin Moier (claudia.villar@moier.co) creó el usuario juan.gomez@moier.co"]
  },
  {
    className: "",
    data: ["Normal", "09/09/2023 - 12:10", "Admin Moier (claudia.villar@moier.co) creó el usuario maria.gonzalez@moier.co"]
  },
  {
    className: "table-warning",
    data: ["Alarma", "09/09/2023 - 13:09", "maria.garcia@moier.co intentó iniciar sesión contraseña incorrecta"]
  },
  {
    className: "",
    data: ["Normal", "09/09/2023 - 13:11", "maria.garcia@moier.co inició sesión correctamente"]
  },
  {
    className: "",
    data: ["Normal", "09/09/2023 - 13:13", "maria.gonzalez@moier.co inició sesión correctamente"]
  },
  {
    className: "",
    data: ["Normal", "09/09/2023 - 14:11", "Admin Moier (claudia.villar@moier.co) creó el usuario laura.martinez@moier.co"]
  },
  {
    className: "table-warning",
    data: ["Alarma", "09/09/2023 - 15:13", "laura.martinez@moier.co intentó iniciar sesión contraseña incorrecta"]
  },
  {
    className: "",
    data: ["Normal", "10/09/2023 - 16:15", "maria.garcia@moier.co inició sesión correctamente"]
  },
  {
    className: "",
    data: ["Normal", "12/09/2023 - 10:19", "Admin Moier (claudia.villar@moier.co) creó el usuario jose.jimenez@moier.co"]
  }
];

const accesslogbody = [
  {
    className: "",
    data: ["Normal", "04/03/2024 - 17:05", "David Martinez (david.martinez@kooks.me) añadió la IP 217.160.0.0/24 al filtro por IP"]
  },
  {
    className: "",
    data: ["Normal", "04/03/2024 - 17:02", "David Martinez (david.martinez@kooks.me) habilitó el filtrado por IP"]
  },
  {
    className: "",
    data: ["Normal", "04/03/2024 - 15:13", "aroca.dealfonso@kooks.me inició sesión correctamente"]
  },
  {
    className: "table-warning",
    data: ["Alarma", "04/03/2024 - 15:13", "aroca.dealfonso@kooks.me intentó iniciar sesión contraseña incorrecta"]
  },
  {
    className: "",
    data: ["Normal", "03/03/2024 - 17:52", "David Martinez (david.martinez@kooks.me) deshabilitó el usuario puchol.leiva@kooks.me"]
  },
  {
    className: "",
    data: ["Normal", "03/03/2024 - 17:51", "David Martinez (david.martinez@kooks.me) deshabilitó el usuario jordan.ginez@kooks.me"]
  }
];
const logbodykooks = [
  {
      "className": "",
      "data": [
          "Normal",
          "15/4/2024 - 17:28",
          "jimenez.soard@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/4/2024 - 19:56",
          "jimenez.soard@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/4/2024 - 13:09",
          "aroca.dealfonso@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/4/2024 - 14:00",
          "aroca.dealfonso@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/4/2024 - 14:09",
          "carvallo.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/4/2024 - 16:13",
          "perez.gallego@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/4/2024 - 17:07",
          "carvallo.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/4/2024 - 18:40",
          "perez.gallego@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/4/2024 - 12:15",
          "carvallo.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/4/2024 - 13:36",
          "carvallo.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 13:34",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 14:25",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 14:39",
          "zambrano.sabater@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 14:43",
          "jimenez.soard@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 15:34",
          "jimenez.soard@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 16:23",
          "zambrano.sabater@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 10:16",
          "lamwahi.miquel@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 12:15",
          "lamwahi.miquel@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 13:47",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 13:54",
          "aleixandre.espada@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 15:50",
          "jimenez.soard@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 16:00",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 16:27",
          "aleixandre.espada@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 17:09",
          "jimenez.soard@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 11:23",
          "aroca.dealfonso@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 12:00",
          "aroca.dealfonso@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 12:02",
          "david.martinez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 12:47",
          "david.martinez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 13:00",
          "lopez.sanjose@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 15:43",
          "lopez.sanjose@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 10:23",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 12:14",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 12:31",
          "sanchez.rodriguez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 15:14",
          "sanchez.rodriguez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 17:15",
          "quimiz.bautista@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 19:37",
          "quimiz.bautista@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 12:36",
          "marques.gines@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 12:46",
          "torres.sanchis@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 13:44",
          "martinez.raimondo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 14:09",
          "marques.gines@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 15:44",
          "torres.sanchis@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 15:55",
          "martinez.raimondo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 11:58",
          "martinez.raimondo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 12:01",
          "sanchez.rodriguez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 12:18",
          "martinez.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 12:33",
          "martinez.raimondo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 13:24",
          "sanchez.rodriguez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 14:47",
          "martinez.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 16:45",
          "vidal.gomez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 17:41",
          "vidal.gomez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 12:54",
          "martinez.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 13:19",
          "pastor.fayos@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 15:18",
          "martinez.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 15:18",
          "pastor.fayos@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 15:30",
          "gil.garcia@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 16:04",
          "gil.garcia@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 13:30",
          "pastor.fayos@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 14:36",
          "pastor.fayos@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 14:47",
          "garcia.delpuerto@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 15:41",
          "garcia.delpuerto@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 16:00",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 16:42",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 14:11",
          "lopez.sanjose@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 15:01",
          "lopez.sanjose@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 16:40",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 17:20",
          "ramon.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 17:58",
          "ramon.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 19:08",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/5/2024 - 13:41",
          "ramon.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/5/2024 - 16:06",
          "ramon.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 12:41",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 13:19",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 12:18",
          "david.martinez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 13:41",
          "david.martinez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 15:59",
          "campos.lopez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 18:33",
          "campos.lopez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 13:23",
          "moudrik.esteban@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 14:07",
          "palomar.nidaguila@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 15:52",
          "moudrik.esteban@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 16:23",
          "aleixandre.espada@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 17:06",
          "palomar.nidaguila@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 17:18",
          "aleixandre.espada@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 17:46",
          "medina.checa@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 19:16",
          "medina.checa@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 13:50",
          "lamwahi.miquel@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 14:16",
          "aleixandre.espada@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 15:06",
          "aleixandre.espada@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 15:43",
          "lamwahi.miquel@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 16:01",
          "gil.garcia@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 17:38",
          "sanchez.fambuena@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 17:47",
          "gil.garcia@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/5/2024 - 19:13",
          "sanchez.fambuena@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 16:07",
          "moudrik.esteban@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 16:49",
          "canela.bargues@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 17:04",
          "lopez.exposito@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 17:40",
          "moudrik.esteban@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 18:25",
          "lopez.exposito@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 19:31",
          "canela.bargues@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 11:50",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 13:12",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 15:39",
          "zambrano.sabater@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 16:17",
          "ramon.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 16:56",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 17:18",
          "zambrano.sabater@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 17:30",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 18:44",
          "ramon.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 15:33",
          "sanchez.lopez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 16:10",
          "sanchez.lopez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/5/2024 - 10:09",
          "canela.bargues@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/5/2024 - 11:42",
          "canela.bargues@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 10:51",
          "torro.calatayud@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 12:29",
          "torro.calatayud@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/5/2024 - 16:19",
          "lopez.exposito@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/5/2024 - 17:10",
          "lopez.exposito@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 12:11",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 13:18",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 15:41",
          "ramon.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 15:56",
          "torro.calatayud@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 16:22",
          "aroca.dealfonso@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 16:28",
          "torro.calatayud@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 16:50",
          "ramon.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 17:07",
          "aroca.dealfonso@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 13:51",
          "edine.brisa@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 16:02",
          "edine.brisa@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 17:10",
          "pastor.bonmati@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 19:51",
          "pastor.bonmati@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 10:01",
          "sanchez.fambuena@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 10:03",
          "marques.gines@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 12:43",
          "marques.gines@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 12:47",
          "sanchez.fambuena@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 14:11",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 15:42",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 11:09",
          "sanchez.fambuena@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 12:14",
          "sanchez.fambuena@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 15:10",
          "carvallo.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 15:35",
          "hernandez.cedelo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 17:12",
          "carvallo.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 18:06",
          "hernandez.cedelo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/5/2024 - 17:51",
          "lopez.exposito@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/5/2024 - 20:30",
          "lopez.exposito@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 10:05",
          "lamwahi.miquel@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 10:52",
          "lamwahi.miquel@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 13:15",
          "escobar.asensio@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 15:55",
          "escobar.asensio@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 16:12",
          "calleja.gimeno@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 16:24",
          "edine.brisa@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 17:18",
          "edine.brisa@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/5/2024 - 18:47",
          "calleja.gimeno@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 13:06",
          "marques.gines@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 14:11",
          "marques.gines@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 14:32",
          "tecles.nieto@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 15:27",
          "martin.real@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 15:39",
          "tecles.nieto@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 16:59",
          "martin.real@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 11:16",
          "pastor.fayos@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 13:13",
          "pastor.fayos@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 14:43",
          "edine.brisa@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 16:59",
          "gimeno.ibañez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 17:00",
          "edine.brisa@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 17:29",
          "gimeno.ibañez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 10:29",
          "pastor.fayos@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 11:06",
          "martinez.raimondo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 12:08",
          "pastor.fayos@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 13:46",
          "martinez.raimondo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 15:12",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 17:47",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 18:02",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 19:19",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/5/2024 - 14:15",
          "florent.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/5/2024 - 16:26",
          "florent.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 11:05",
          "gimeno.ibañez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 13:02",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 13:21",
          "gimeno.ibañez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 15:36",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 15:39",
          "carvallo.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 16:10",
          "carvallo.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 16:26",
          "lopez.sanjose@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "31/5/2024 - 17:47",
          "lopez.sanjose@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 13:47",
          "martinez.raimondo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 14:51",
          "campos.lopez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 15:57",
          "campos.lopez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 16:30",
          "martinez.raimondo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 16:41",
          "zambrano.sabater@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 18:37",
          "zambrano.sabater@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 10:33",
          "nacher.martinez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 11:39",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 12:32",
          "nacher.martinez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 14:21",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 14:26",
          "galindo.grande@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 16:16",
          "galindo.grande@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 16:17",
          "martinez.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 19:16",
          "martinez.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 12:56",
          "hernandez.cedelo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 15:04",
          "hernandez.cedelo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 11:59",
          "zambrano.sabater@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 12:21",
          "campos.lopez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 13:36",
          "campos.lopez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 13:51",
          "carvallo.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 14:39",
          "zambrano.sabater@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 15:16",
          "carvallo.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 14:55",
          "perez.gallego@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 15:59",
          "florent.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 16:23",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 16:43",
          "ballester.souto@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 17:12",
          "florent.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 17:14",
          "perez.gallego@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 17:40",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 18:40",
          "ballester.souto@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/6/2024 - 10:24",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/6/2024 - 11:06",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/6/2024 - 17:53",
          "marques.gines@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/6/2024 - 18:36",
          "marques.gines@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 17:18",
          "edine.brisa@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 18:26",
          "edine.brisa@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/6/2024 - 11:53",
          "tecles.nieto@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/6/2024 - 13:39",
          "tecles.nieto@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 13:39",
          "gil.garcia@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 14:50",
          "canela.bargues@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 15:42",
          "gil.garcia@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 15:57",
          "canela.bargues@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 16:14",
          "palomar.nidaguila@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 17:33",
          "palomar.nidaguila@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 11:15",
          "hernandez.cedelo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 12:02",
          "hernandez.cedelo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 14:02",
          "sanchez.lopez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 14:26",
          "vidal.gomez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 15:09",
          "sanchez.fambuena@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 15:41",
          "sanchez.fambuena@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 16:58",
          "vidal.gomez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 17:01",
          "sanchez.lopez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 11:52",
          "pastor.bonmati@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 12:52",
          "pastor.bonmati@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 13:00",
          "aleixandre.espada@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 13:30",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 15:08",
          "aleixandre.espada@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 15:52",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 11:24",
          "florent.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 12:13",
          "florent.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 15:15",
          "campos.lopez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 16:12",
          "gil.garcia@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 17:53",
          "campos.lopez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 18:50",
          "gil.garcia@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/6/2024 - 14:26",
          "sanchez.rodriguez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/6/2024 - 15:26",
          "sanchez.rodriguez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/6/2024 - 15:33",
          "hernandez.cedelo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/6/2024 - 17:13",
          "hernandez.cedelo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 11:26",
          "edine.brisa@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 12:23",
          "edine.brisa@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 12:48",
          "lopez.exposito@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 15:13",
          "hernandez.cedelo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 15:15",
          "quimiz.bautista@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 15:16",
          "lopez.exposito@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 16:12",
          "quimiz.bautista@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 17:07",
          "hernandez.cedelo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 10:57",
          "lamwahi.miquel@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 13:12",
          "lamwahi.miquel@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 13:21",
          "zambrano.sabater@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 14:29",
          "zambrano.sabater@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 15:21",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 16:46",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/6/2024 - 10:01",
          "aroca.dealfonso@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/6/2024 - 12:14",
          "aroca.dealfonso@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/6/2024 - 12:58",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/6/2024 - 14:11",
          "canela.bargues@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/6/2024 - 14:58",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/6/2024 - 16:37",
          "canela.bargues@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/6/2024 - 11:04",
          "martinez.raimondo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/6/2024 - 11:38",
          "martinez.raimondo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/6/2024 - 12:17",
          "pastor.fayos@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/6/2024 - 14:39",
          "pastor.fayos@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/6/2024 - 10:58",
          "martinez.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/6/2024 - 13:33",
          "martinez.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 12:52",
          "bodega.gozo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 15:39",
          "bodega.gozo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 15:45",
          "david.martinez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 17:01",
          "david.martinez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 12:34",
          "florent.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 13:23",
          "martinez.raimondo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 15:04",
          "florent.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 15:19",
          "martinez.raimondo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 17:43",
          "leon.roca@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 20:10",
          "leon.roca@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 10:00",
          "garcia.delpuerto@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 10:34",
          "garcia.delpuerto@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 10:38",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 12:34",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 15:04",
          "puchades.diaz@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 16:16",
          "puchades.diaz@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 11:14",
          "canela.bargues@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 12:17",
          "canela.bargues@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 12:27",
          "jimenez.soard@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 13:24",
          "jimenez.soard@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 14:15",
          "jimenez.soard@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 14:44",
          "sanchez.rodriguez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 15:02",
          "jimenez.soard@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 16:35",
          "sanchez.rodriguez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 14:36",
          "nacher.martinez@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 15:47",
          "nacher.martinez@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 12:25",
          "quimiz.bautista@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 12:39",
          "torres.sanchis@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 13:11",
          "lopez.exposito@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 13:14",
          "torres.sanchis@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 14:52",
          "quimiz.bautista@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 15:43",
          "lopez.exposito@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 10:47",
          "florent.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 10:48",
          "calleja.gimeno@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 11:31",
          "florent.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 12:44",
          "galindo.grande@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 13:14",
          "calleja.gimeno@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 14:02",
          "galindo.grande@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 15:53",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 16:31",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/7/2024 - 10:13",
          "calleja.gimeno@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/7/2024 - 10:29",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/7/2024 - 11:11",
          "calleja.gimeno@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/7/2024 - 11:21",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/7/2024 - 16:04",
          "gines.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/7/2024 - 16:54",
          "gines.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 11:35",
          "delatorre.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 12:35",
          "delatorre.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 14:42",
          "sanchez.fambuena@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 15:36",
          "sanchez.fambuena@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 16:13",
          "ramon.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 17:54",
          "ramon.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 11:49",
          "florent.palomo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 13:44",
          "florent.palomo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 16:51",
          "bodega.gozo@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 17:24",
          "ballester.souto@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 17:32",
          "bodega.gozo@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 17:41",
          "marques.gines@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 18:44",
          "marques.gines@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 20:15",
          "ballester.souto@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 15:33",
          "ramon.landete@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 17:25",
          "ramon.landete@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/7/2024 - 17:35",
          "martinez.blasco@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/7/2024 - 19:15",
          "martinez.blasco@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/7/2024 - 13:01",
          "medina.checa@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/7/2024 - 15:14",
          "medina.checa@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 10:02",
          "escobar.asensio@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 12:38",
          "escobar.asensio@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 16:48",
          "moudrik.esteban@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 19:40",
          "moudrik.esteban@kooks.me se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 17:02",
          "zambrano.sabater@kooks.me se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 18:50",
          "zambrano.sabater@kooks.me se desconectó"
      ]
  }
];
const logbodymoier = [
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 10:58",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 11:57",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 13:45",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 13:51",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 14:49",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 15:47",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 16:24",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/4/2024 - 19:07",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/4/2024 - 14:21",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/4/2024 - 15:50",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/4/2024 - 16:02",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/4/2024 - 17:25",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/4/2024 - 10:23",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/4/2024 - 12:09",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/4/2024 - 15:25",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/4/2024 - 16:11",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 12:26",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 13:12",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 15:01",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/4/2024 - 15:56",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 10:05",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 12:20",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 12:28",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 14:14",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 15:04",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 16:35",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 16:56",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/4/2024 - 19:48",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 10:33",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 11:41",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 12:06",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 12:47",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 13:01",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 14:48",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 17:14",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/4/2024 - 20:00",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 12:25",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 13:21",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 14:46",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 15:47",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 17:34",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/4/2024 - 18:44",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/4/2024 - 17:16",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/4/2024 - 18:34",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/4/2024 - 14:39",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/4/2024 - 16:31",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 12:45",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 14:01",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 14:42",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 15:45",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 17:22",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 17:55",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 18:22",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "25/4/2024 - 20:05",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 13:47",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 14:17",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 16:41",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 17:06",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 17:47",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/4/2024 - 19:20",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 14:07",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/4/2024 - 14:45",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/4/2024 - 14:11",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/4/2024 - 15:49",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 14:06",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 14:18",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 15:28",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 16:19",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 16:55",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 17:01",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 19:15",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/4/2024 - 19:23",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/4/2024 - 10:14",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/4/2024 - 11:13",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 10:09",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 10:55",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 11:09",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 12:54",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 13:43",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 13:44",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 16:49",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/5/2024 - 17:49",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/5/2024 - 14:51",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/5/2024 - 17:08",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 13:03",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 14:21",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 15:02",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 16:13",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 16:21",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/5/2024 - 18:12",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 10:38",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 12:14",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 12:21",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 13:38",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 14:48",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 15:03",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 15:35",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/5/2024 - 16:28",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 10:30",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 12:42",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 16:49",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/5/2024 - 19:19",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 12:29",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 15:07",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 16:53",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/5/2024 - 19:42",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/5/2024 - 10:19",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/5/2024 - 13:04",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/5/2024 - 14:57",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/5/2024 - 17:38",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 11:06",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 11:16",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 11:51",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 12:27",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 13:35",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 14:50",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 16:10",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/5/2024 - 16:14",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/5/2024 - 12:39",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/5/2024 - 12:56",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/5/2024 - 14:18",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/5/2024 - 14:30",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 11:39",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 12:22",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 13:31",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 13:59",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 16:03",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/5/2024 - 16:55",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 10:59",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 13:11",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 15:49",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 16:05",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 18:27",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/5/2024 - 18:44",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/5/2024 - 14:18",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "15/5/2024 - 15:35",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 12:14",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 13:29",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 14:04",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 15:11",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 15:33",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 15:47",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 16:24",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/5/2024 - 18:09",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/5/2024 - 13:34",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/5/2024 - 14:17",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/5/2024 - 17:54",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/5/2024 - 20:00",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 16:04",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 16:16",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 17:21",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/5/2024 - 18:12",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 11:37",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 13:11",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 13:41",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 14:01",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 17:33",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 17:55",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 19:12",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "19/5/2024 - 20:08",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 11:48",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 13:03",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 13:59",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 15:49",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 15:53",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "20/5/2024 - 18:32",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 11:43",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 14:16",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 14:45",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 15:57",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 16:27",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 17:53",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 18:41",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/5/2024 - 19:18",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 15:26",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/5/2024 - 17:09",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 17:18",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/5/2024 - 19:38",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 12:03",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/5/2024 - 14:46",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 14:24",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/5/2024 - 15:22",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/5/2024 - 14:40",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/5/2024 - 15:53",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/5/2024 - 16:55",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/5/2024 - 19:37",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/5/2024 - 16:45",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/5/2024 - 17:31",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 10:07",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 10:57",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 13:58",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/6/2024 - 15:24",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 10:12",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "3/6/2024 - 11:23",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 10:00",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 12:06",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 12:08",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 13:35",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 15:28",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 17:49",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 17:50",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/6/2024 - 18:40",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 13:36",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 16:05",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 17:58",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "5/6/2024 - 20:33",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 10:11",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/6/2024 - 10:44",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 11:11",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 13:23",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 14:43",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 14:44",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 15:24",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 17:04",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 17:13",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "8/6/2024 - 19:38",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/6/2024 - 12:35",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/6/2024 - 14:51",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/6/2024 - 15:16",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/6/2024 - 15:34",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 13:28",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 16:11",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 16:15",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/6/2024 - 18:23",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 10:21",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/6/2024 - 11:14",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 15:15",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 17:16",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 18:13",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/6/2024 - 19:08",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 10:58",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 13:40",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 13:50",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/6/2024 - 15:34",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/6/2024 - 15:47",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "14/6/2024 - 18:37",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 13:39",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 13:42",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 14:48",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 15:29",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 15:52",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 15:58",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 17:38",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "16/6/2024 - 20:01",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 10:24",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 10:55",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 15:05",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "17/6/2024 - 16:58",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 14:18",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 14:41",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 14:52",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 16:47",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 16:55",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 17:11",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 17:27",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "18/6/2024 - 18:14",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/6/2024 - 12:14",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/6/2024 - 13:32",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/6/2024 - 13:54",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "21/6/2024 - 15:45",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 10:44",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 13:36",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 16:24",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "22/6/2024 - 18:06",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 12:20",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 15:14",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 16:45",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "23/6/2024 - 18:41",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 12:12",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 12:58",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 13:49",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 16:26",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 17:30",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "24/6/2024 - 18:37",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 11:07",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 11:37",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 12:39",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 13:38",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 13:40",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 14:14",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 15:55",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "26/6/2024 - 17:20",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/6/2024 - 14:07",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/6/2024 - 16:22",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/6/2024 - 16:58",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/6/2024 - 17:19",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/6/2024 - 17:22",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "27/6/2024 - 18:58",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 10:06",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 11:19",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 17:58",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "28/6/2024 - 18:57",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 11:09",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 13:28",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 17:19",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "29/6/2024 - 19:03",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 13:49",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 15:23",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 16:03",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 16:12",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 16:31",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "30/6/2024 - 17:33",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 10:17",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 11:31",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 11:41",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 12:50",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 14:02",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 15:01",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 16:46",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "1/7/2024 - 19:25",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 11:39",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 14:12",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 17:20",
          "juan.gomez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 17:20",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 18:09",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "2/7/2024 - 18:24",
          "juan.gomez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 13:07",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "4/7/2024 - 13:55",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 12:07",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 13:19",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 14:16",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 15:00",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 15:18",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 16:00",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 16:57",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "6/7/2024 - 19:41",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 10:38",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 13:05",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 13:13",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 13:27",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 13:55",
          "laura.martinez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 14:18",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 15:07",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "7/7/2024 - 15:26",
          "laura.martinez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/7/2024 - 16:08",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "9/7/2024 - 18:33",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/7/2024 - 13:43",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "10/7/2024 - 16:31",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 13:49",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 15:39",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 15:49",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 16:01",
          "francisco.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 17:32",
          "ana.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 18:04",
          "jose.jimenez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 18:44",
          "francisco.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "11/7/2024 - 19:53",
          "ana.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/7/2024 - 13:52",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/7/2024 - 16:13",
          "maria.garcia@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/7/2024 - 16:16",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "12/7/2024 - 19:03",
          "maria.garcia@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 10:48",
          "teresa.arrebola@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 11:30",
          "teresa.arrebola@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 12:24",
          "maria.gonzalez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 14:03",
          "maria.gonzalez@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 17:14",
          "jose.jimenez@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 17:35",
          "claudia.villar@moier.co se conectó utilizando el protocolo SSL/TLS"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 18:26",
          "claudia.villar@moier.co se desconectó"
      ]
  },
  {
      "className": "",
      "data": [
          "Normal",
          "13/7/2024 - 18:54",
          "jose.jimenez@moier.co se desconectó"
      ]
  }
];
const logbody = [
    {
        "className": "",
        "data": [
            "Normal",
            "19/2/2024 - 15:26",
            "jorge.ortega@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/2/2024 - 15:52",
            "ingenieria@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/2/2024 - 16:32",
            "claudia.molina@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/2/2024 - 16:59",
            "jorge.ortega@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/2/2024 - 17:35",
            "ingenieria@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/2/2024 - 18:26",
            "claudia.molina@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "20/2/2024 - 15:19",
            "alberto.mendez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "20/2/2024 - 16:34",
            "ricardo.flores@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "20/2/2024 - 16:54",
            "alberto.mendez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "20/2/2024 - 17:17",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "20/2/2024 - 19:11",
            "ricardo.flores@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "20/2/2024 - 19:50",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/2/2024 - 12:14",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/2/2024 - 14:21",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/2/2024 - 10:35",
            "claudia.molina@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/2/2024 - 13:03",
            "claudia.molina@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/2/2024 - 12:51",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/2/2024 - 14:22",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/2/2024 - 14:38",
            "victoria.cortes@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/2/2024 - 16:44",
            "jorge.ortega@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/2/2024 - 17:29",
            "victoria.cortes@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/2/2024 - 19:30",
            "jorge.ortega@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/2/2024 - 10:16",
            "raul.santos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/2/2024 - 10:23",
            "isabel.vargas@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/2/2024 - 10:57",
            "raul.santos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/2/2024 - 11:42",
            "isabel.vargas@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/2/2024 - 12:58",
            "patricia.ramos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/2/2024 - 15:49",
            "patricia.ramos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 13:30",
            "claudia.molina@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 14:13",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 14:47",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 15:33",
            "beatriz.vera@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 15:47",
            "claudia.molina@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 15:59",
            "carlos.lopez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 17:30",
            "beatriz.vera@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/2/2024 - 17:31",
            "carlos.lopez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 11:31",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 11:40",
            "beatriz.vera@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 12:27",
            "beatriz.vera@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 13:11",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 15:12",
            "victoria.cortes@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 16:22",
            "victoria.cortes@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 17:47",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/2/2024 - 19:17",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/2/2024 - 14:12",
            "patricia.ramos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/2/2024 - 16:27",
            "patricia.ramos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/2/2024 - 10:32",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/2/2024 - 10:57",
            "raul.santos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/2/2024 - 11:35",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/2/2024 - 13:27",
            "raul.santos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/3/2024 - 12:03",
            "carlos.lopez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/3/2024 - 12:04",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/3/2024 - 14:08",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/3/2024 - 14:55",
            "carlos.lopez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/3/2024 - 17:05",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/3/2024 - 18:57",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/3/2024 - 12:43",
            "carlos.lopez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/3/2024 - 13:01",
            "sergio.iglesias@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/3/2024 - 13:56",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/3/2024 - 14:39",
            "sergio.iglesias@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/3/2024 - 14:52",
            "carlos.lopez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/3/2024 - 16:46",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/3/2024 - 14:57",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/3/2024 - 15:38",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/3/2024 - 17:02",
            "maria.garcia@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/3/2024 - 19:39",
            "maria.garcia@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/3/2024 - 15:16",
            "ingenieria@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/3/2024 - 15:57",
            "ingenieria@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/3/2024 - 16:19",
            "natalia.diaz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/3/2024 - 18:16",
            "natalia.diaz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/3/2024 - 11:18",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/3/2024 - 13:18",
            "isabel.vargas@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/3/2024 - 13:37",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/3/2024 - 14:07",
            "pedro.gonzalez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/3/2024 - 14:29",
            "isabel.vargas@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/3/2024 - 15:46",
            "pedro.gonzalez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/3/2024 - 13:17",
            "fernando.morales@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/3/2024 - 14:13",
            "fernando.morales@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/3/2024 - 14:48",
            "pedro.gonzalez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/3/2024 - 17:22",
            "pedro.gonzalez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/3/2024 - 10:24",
            "beatriz.vera@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/3/2024 - 11:41",
            "beatriz.vera@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/3/2024 - 12:03",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/3/2024 - 13:05",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/3/2024 - 16:44",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/3/2024 - 17:55",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/3/2024 - 13:44",
            "victoria.cortes@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/3/2024 - 15:10",
            "victoria.cortes@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 15:23",
            "carlos.lopez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 15:55",
            "raul.santos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 16:06",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 16:10",
            "ricardo.flores@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 17:50",
            "ricardo.flores@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 17:59",
            "raul.santos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 18:17",
            "carlos.lopez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/3/2024 - 18:29",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/3/2024 - 16:50",
            "pedro.gonzalez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/3/2024 - 18:08",
            "pedro.gonzalez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 15:16",
            "ingenieria@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 15:50",
            "alberto.mendez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 16:16",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 17:02",
            "ingenieria@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 17:16",
            "alberto.mendez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 17:53",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 18:59",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/3/2024 - 20:04",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/3/2024 - 11:30",
            "victoria.cortes@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/3/2024 - 13:07",
            "victoria.cortes@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/3/2024 - 14:00",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/3/2024 - 14:29",
            "raul.santos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/3/2024 - 16:00",
            "raul.santos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/3/2024 - 16:59",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/3/2024 - 17:34",
            "maria.garcia@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/3/2024 - 19:46",
            "maria.garcia@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 10:56",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 13:02",
            "jorge.ortega@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 13:21",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 16:00",
            "jorge.ortega@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 17:43",
            "sergio.iglesias@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 17:51",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 19:08",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/3/2024 - 19:10",
            "sergio.iglesias@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/3/2024 - 16:45",
            "carlos.lopez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/3/2024 - 16:53",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/3/2024 - 19:17",
            "carlos.lopez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/3/2024 - 19:36",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/3/2024 - 11:49",
            "david.gimenez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/3/2024 - 12:07",
            "ricardo.flores@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/3/2024 - 12:26",
            "david.gimenez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/3/2024 - 12:36",
            "maria.garcia@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/3/2024 - 14:28",
            "ricardo.flores@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/3/2024 - 14:38",
            "maria.garcia@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 10:17",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 11:47",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 12:56",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 13:46",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 14:18",
            "victoria.cortes@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 14:56",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 15:05",
            "victoria.cortes@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "22/3/2024 - 17:40",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/3/2024 - 14:39",
            "sergio.iglesias@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "23/3/2024 - 17:23",
            "sergio.iglesias@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 10:35",
            "pedro.gonzalez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 10:40",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 11:44",
            "pedro.gonzalez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 12:18",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 12:42",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 14:45",
            "jorge.ortega@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 15:16",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/3/2024 - 16:06",
            "jorge.ortega@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/3/2024 - 11:33",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/3/2024 - 12:14",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/3/2024 - 10:10",
            "fernando.morales@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/3/2024 - 11:03",
            "fernando.morales@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/3/2024 - 11:24",
            "carlos.lopez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/3/2024 - 12:02",
            "carlos.lopez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/3/2024 - 15:12",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/3/2024 - 16:31",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/3/2024 - 11:54",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/3/2024 - 13:03",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/3/2024 - 13:33",
            "natalia.diaz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/3/2024 - 14:31",
            "natalia.diaz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 10:10",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 11:19",
            "pedro.gonzalez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 11:50",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 13:26",
            "isabel.vargas@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 14:03",
            "pedro.gonzalez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 16:25",
            "isabel.vargas@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 16:32",
            "natalia.diaz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/3/2024 - 19:13",
            "natalia.diaz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "31/3/2024 - 15:30",
            "sofia.rodriguez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "31/3/2024 - 16:39",
            "ingenieria@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "31/3/2024 - 18:12",
            "sofia.rodriguez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "31/3/2024 - 18:40",
            "ingenieria@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/4/2024 - 13:05",
            "ingenieria@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/4/2024 - 14:09",
            "andres.herrera@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/4/2024 - 15:11",
            "andres.herrera@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/4/2024 - 15:42",
            "ingenieria@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/4/2024 - 17:17",
            "maria.garcia@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/4/2024 - 17:56",
            "maria.garcia@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/4/2024 - 10:57",
            "patricia.ramos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/4/2024 - 13:01",
            "patricia.ramos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/4/2024 - 13:06",
            "ricardo.flores@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/4/2024 - 15:27",
            "ricardo.flores@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/4/2024 - 10:46",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/4/2024 - 12:18",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/4/2024 - 14:00",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/4/2024 - 14:38",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/4/2024 - 17:54",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "5/4/2024 - 19:13",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 12:01",
            "alberto.mendez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 13:52",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 14:26",
            "alberto.mendez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 14:26",
            "claudia.molina@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 16:14",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 16:26",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 17:09",
            "claudia.molina@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/4/2024 - 19:05",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/4/2024 - 11:20",
            "natalia.diaz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/4/2024 - 14:15",
            "natalia.diaz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/4/2024 - 11:44",
            "natalia.diaz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/4/2024 - 13:08",
            "natalia.diaz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/4/2024 - 15:17",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/4/2024 - 16:05",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/4/2024 - 16:18",
            "david.gimenez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/4/2024 - 17:55",
            "david.gimenez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/4/2024 - 13:02",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/4/2024 - 14:26",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 10:25",
            "natalia.diaz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 12:29",
            "natalia.diaz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 13:52",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 15:16",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 16:34",
            "claudia.molina@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 17:16",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 18:45",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/4/2024 - 19:24",
            "claudia.molina@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/4/2024 - 11:37",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/4/2024 - 11:40",
            "alberto.mendez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/4/2024 - 12:19",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/4/2024 - 12:33",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/4/2024 - 14:26",
            "alberto.mendez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/4/2024 - 15:29",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/4/2024 - 12:15",
            "sergio.iglesias@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/4/2024 - 14:49",
            "sergio.iglesias@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/4/2024 - 14:50",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/4/2024 - 16:40",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/4/2024 - 17:53",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/4/2024 - 20:19",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/4/2024 - 13:15",
            "david.gimenez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/4/2024 - 13:59",
            "david.gimenez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/4/2024 - 17:19",
            "pedro.gonzalez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/4/2024 - 18:40",
            "pedro.gonzalez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/4/2024 - 17:33",
            "david.gimenez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/4/2024 - 18:34",
            "david.gimenez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 10:47",
            "adrian@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 12:11",
            "adrian@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 15:05",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 15:37",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 16:02",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 16:24",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 17:44",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/4/2024 - 17:48",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/4/2024 - 11:37",
            "natalia.diaz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/4/2024 - 13:04",
            "natalia.diaz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/4/2024 - 16:24",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "21/4/2024 - 19:15",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/4/2024 - 12:10",
            "laura.martinez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/4/2024 - 13:09",
            "laura.martinez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/4/2024 - 13:16",
            "raul.santos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/4/2024 - 15:18",
            "raul.santos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/4/2024 - 17:55",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "24/4/2024 - 20:02",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/4/2024 - 15:21",
            "maria.garcia@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/4/2024 - 15:58",
            "jorge.ortega@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/4/2024 - 16:40",
            "jorge.ortega@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "25/4/2024 - 16:43",
            "maria.garcia@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 11:13",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 13:24",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 13:52",
            "ana.ruiz@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 14:40",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 15:25",
            "ana.ruiz@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 16:05",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 17:27",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "26/4/2024 - 19:11",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/4/2024 - 13:00",
            "fernando.morales@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/4/2024 - 13:33",
            "fernando.morales@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/4/2024 - 15:22",
            "ingenieria@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "27/4/2024 - 18:16",
            "ingenieria@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/4/2024 - 10:42",
            "claudia.molina@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/4/2024 - 12:19",
            "claudia.molina@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/4/2024 - 14:53",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/4/2024 - 17:02",
            "laura.martinez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/4/2024 - 17:14",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "28/4/2024 - 18:01",
            "laura.martinez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/4/2024 - 13:18",
            "laura.martinez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/4/2024 - 13:46",
            "victoria.cortes@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/4/2024 - 14:15",
            "laura.martinez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/4/2024 - 14:49",
            "victoria.cortes@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/4/2024 - 15:47",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "29/4/2024 - 18:14",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 11:20",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 13:50",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 13:53",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 16:18",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 16:33",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 17:21",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 18:20",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "30/4/2024 - 20:14",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/5/2024 - 13:05",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/5/2024 - 13:30",
            "fernando.morales@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/5/2024 - 13:56",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/5/2024 - 14:39",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/5/2024 - 15:23",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "1/5/2024 - 15:29",
            "fernando.morales@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/5/2024 - 10:11",
            "alberto.mendez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/5/2024 - 10:50",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/5/2024 - 11:04",
            "alberto.mendez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "2/5/2024 - 13:43",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "3/5/2024 - 12:07",
            "raul.santos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "3/5/2024 - 12:46",
            "claudia.molina@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "3/5/2024 - 12:49",
            "raul.santos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "3/5/2024 - 14:17",
            "claudia.molina@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/5/2024 - 10:10",
            "sofia.rodriguez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/5/2024 - 12:15",
            "sofia.rodriguez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/5/2024 - 17:21",
            "beatriz.vera@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/5/2024 - 17:36",
            "isabel.vargas@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/5/2024 - 19:15",
            "beatriz.vera@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "4/5/2024 - 20:33",
            "isabel.vargas@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "6/5/2024 - 12:54",
            "juan.perez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "6/5/2024 - 13:39",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "6/5/2024 - 14:52",
            "juan.perez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "6/5/2024 - 15:14",
            "patricia.ramos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "6/5/2024 - 15:16",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "6/5/2024 - 16:14",
            "patricia.ramos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 11:58",
            "andres.herrera@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 14:09",
            "sofia.rodriguez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 14:33",
            "andres.herrera@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 15:42",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 17:07",
            "sofia.rodriguez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 17:09",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 17:25",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "7/5/2024 - 18:53",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/5/2024 - 11:55",
            "marta.navarro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/5/2024 - 12:52",
            "marta.navarro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/5/2024 - 16:28",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "8/5/2024 - 19:23",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/5/2024 - 14:57",
            "raul.santos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "9/5/2024 - 15:42",
            "raul.santos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/5/2024 - 10:19",
            "pablo.silva@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/5/2024 - 10:49",
            "alberto.mendez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/5/2024 - 12:47",
            "pablo.silva@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/5/2024 - 13:13",
            "alberto.mendez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/5/2024 - 17:30",
            "patricia.ramos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "10/5/2024 - 18:00",
            "patricia.ramos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/5/2024 - 11:08",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/5/2024 - 11:42",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/5/2024 - 13:07",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "11/5/2024 - 13:19",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/5/2024 - 14:52",
            "patricia.ramos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/5/2024 - 16:51",
            "patricia.ramos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/5/2024 - 17:21",
            "alberto.mendez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "12/5/2024 - 18:32",
            "alberto.mendez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 11:18",
            "carlos.lopez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 12:49",
            "luis.fernandez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 14:08",
            "carlos.lopez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 14:28",
            "isabel.vargas@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 15:08",
            "isabel.vargas@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 15:12",
            "luis.fernandez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 16:19",
            "sofia.rodriguez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "13/5/2024 - 17:23",
            "sofia.rodriguez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/5/2024 - 11:37",
            "rosa@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "14/5/2024 - 14:26",
            "rosa@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/5/2024 - 11:28",
            "monica.castro@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/5/2024 - 13:52",
            "monica.castro@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/5/2024 - 13:57",
            "pedro.gonzalez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "15/5/2024 - 15:10",
            "pedro.gonzalez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/5/2024 - 10:09",
            "patricia.ramos@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/5/2024 - 12:23",
            "patricia.ramos@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/5/2024 - 12:27",
            "david.gimenez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/5/2024 - 12:31",
            "ingenieria@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/5/2024 - 13:58",
            "ingenieria@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "16/5/2024 - 14:40",
            "david.gimenez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/5/2024 - 16:26",
            "externo@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "17/5/2024 - 18:47",
            "externo@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 10:53",
            "victoria.cortes@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 12:25",
            "victoria.cortes@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 14:55",
            "sofia.rodriguez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 16:28",
            "fernando.morales@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 16:38",
            "sofia.rodriguez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 17:57",
            "isabel.vargas@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 18:28",
            "isabel.vargas@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "18/5/2024 - 18:48",
            "fernando.morales@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/5/2024 - 10:47",
            "francisco.sanchez@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/5/2024 - 12:23",
            "francisco.sanchez@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/5/2024 - 13:09",
            "andres.herrera@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/5/2024 - 13:51",
            "elena.romero@lloretproteccion.com se conectó utilizando el protocolo SSL/TLS"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/5/2024 - 14:22",
            "elena.romero@lloretproteccion.com se desconectó"
        ]
    },
    {
        "className": "",
        "data": [
            "Normal",
            "19/5/2024 - 15:18",
            "andres.herrera@lloretproteccion.com se desconectó"
        ]
    }
];

// ##############################
// // // stories for Timeline view
// #############################

const stories = [
  {
    // First story
    inverted: true,
    badgeColor: "danger",
    badgeIcon: "now-ui-icons business_briefcase-24",
    title: "Some Title",
    titleColor: "danger",
    body: (
      <p>
        Wifey made the best Father's Day meal ever. So thankful so happy so
        blessed. Thank you for making my family We just had fun with the
        “future” theme !!! It was a fun night all together ... The always rude
        Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in
        downtown.
      </p>
    ),
    footerTitle: "11 hours ago via Twitter"
  },
  {
    // Second story
    badgeColor: "success",
    badgeIcon: "now-ui-icons design-2_ruler-pencil",
    title: "Another One",
    titleColor: "success",
    body: (
      <p>
        Thank God for the support of my wife and real friends. I also wanted to
        point out that it’s the first album to go number 1 off of streaming!!! I
        love you Ellen and also my number one design rule of anything I do from
        shoes to music to homes is that Kim has to like it....
      </p>
    )
  },
  {
    // Third story
    inverted: true,
    badgeColor: "info",
    badgeIcon: "now-ui-icons gestures_tap-01",
    title: "Another Title",
    titleColor: "info",
    body: (
      <div>
        <p>
          Called I Miss the Old Kanye That’s all it was Kanye And I love you
          like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown
          LA 11:10PM
        </p>
        <p>
          What if Kanye made a song about Kanye Royère doesn't make a Polar bear
          bed but the Polar bear couch is my favorite piece of furniture we own
          It wasn’t any Kanyes Set on his goals Kanye
        </p>
        <hr />
      </div>
    ),
    footer: (
      <UncontrolledButtonDropdown group={false}>
        <DropdownToggle caret className="btn-round" color="info">
          <i className="now-ui-icons design_bullet-list-67" />{" "}
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem header>Header</DropdownItem>
          <DropdownItem disabled>Action</DropdownItem>
          <DropdownItem>Another Action</DropdownItem>
          <DropdownItem divider />
          <DropdownItem>Another Action</DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    )
  },
  {
    // Fourth story
    badgeColor: "warning",
    badgeIcon: "now-ui-icons ui-1_send",
    title: "Another One",
    titleColor: "warning",
    body: (
      <p>
        Tune into Big Boy's 92.3 I'm about to play the first single from Cruel
        Winter also to Kim’s hair and makeup Lorraine jewelry and the whole
        style squad at Balmain and the Yeezy team. Thank you Anna for the invite
        thank you to the whole Vogue team
      </p>
    )
  }
];

// ##############################
// // // stories for Widgets view
// #############################

const widgetStories = [
  {
    // First story
    inverted: true,
    badgeColor: "danger",
    badgeIcon: "now-ui-icons business_briefcase-24",
    title: "Some Title",
    titleColor: "danger",
    body: (
      <p>
        Wifey made the best Father's Day meal ever. So thankful so happy so
        blessed. Thank you for making my family We just had fun with the
        “future” theme !!! It was a fun night all together ... The always rude
        Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in
        downtown.
      </p>
    ),
    footerTitle: "11 hours ago via Twitter"
  },
  {
    // Second story
    inverted: true,
    badgeColor: "success",
    badgeIcon: "now-ui-icons design-2_ruler-pencil",
    title: "Another One",
    titleColor: "success",
    body: (
      <p>
        Thank God for the support of my wife and real friends. I also wanted to
        point out that it’s the first album to go number 1 off of streaming!!! I
        love you Ellen and also my number one design rule of anything I do from
        shoes to music to homes is that Kim has to like it....
      </p>
    )
  },
  {
    // Third story
    inverted: true,
    badgeColor: "info",
    badgeIcon: "now-ui-icons gestures_tap-01",
    title: "Another Title",
    titleColor: "info",
    body: (
      <div>
        <p>
          Called I Miss the Old Kanye That’s all it was Kanye And I love you
          like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown
          LA 11:10PM
        </p>
        <p>
          What if Kanye made a song about Kanye Royère doesn't make a Polar bear
          bed but the Polar bear couch is my favorite piece of furniture we own
          It wasn’t any Kanyes Set on his goals Kanye
        </p>
        <hr />
      </div>
    ),
    footer: (
      <UncontrolledButtonDropdown group={false}>
        <DropdownToggle caret className="btn-round" color="info">
          <i className="now-ui-icons design_bullet-list-67" />
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem header>Header</DropdownItem>
          <DropdownItem disabled>Action</DropdownItem>
          <DropdownItem>Another Action</DropdownItem>
          <DropdownItem divider />
          <DropdownItem>Another Action</DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    )
  }
];

// ##############################
// // // stories for RTL view
// #############################

const widgetStoriesRTL = [
  {
    // First story
    inverted: true,
    badgeColor: "danger",
    badgeIcon: "now-ui-icons business_briefcase-24",
    title: "بعض العنوان",
    titleColor: "danger",
    body: (
      <p>
        قدم أفضل وجبة يوم الأب على الإطلاق. ممتن جدا سعيد جدا حتى المباركة.
        شكراً لك على صنع عائلتي لقد استمتعنا بالموضوع "المستقبلي" !!! كانت ليلة
        ممتعة كل ذلك معا ... عرض كاني فظ دائما في الساعة 2 صباحا بيعت من مشاهير
        مشاهدة
      </p>
    ),
    footerTitle: "قبل 11 ساعة عبر تويتر"
  },
  {
    // Second story
    inverted: true,
    badgeColor: "success",
    badgeIcon: "now-ui-icons design-2_ruler-pencil",
    title: "واحدة أخرى",
    titleColor: "success",
    body: (
      <p>
        أيضًا الإشارة إلى أنه أول ألبوم ينتقل إلى رقم 1 من البث المباشر !!! أنا
        أحبك إلين وأيضا قاعدة بلدي رقم واحد تصميم أي شيء أفعله من الأحذية إلى
        الموسيقى إلى المنازل هو أن كيم يجب أن ترغب في ذلك
      </p>
    )
  },
  {
    // Third story
    inverted: true,
    badgeColor: "info",
    badgeIcon: "now-ui-icons gestures_tap-01",
    title: "عنوان آخر",
    titleColor: "info",
    body: (
      <div>
        <p>
          يسمى أنا أفتقد كاني القديم هذا كل ما كان كاني وأنا أحبك مثل كاني يحب
          كاني مشاهدة مشاهير @ Figueroa و 12 في وسط المدينة LA 11:10 PM
        </p>
        <p>
          ماذا لو قدمت كاني أغنية عن كاني رويير لا تصنع سرير الدب القطبي ولكن
          الأريكة الدببة القطبية هي قطعة الأثاث المفضلة لدينا التي نملكها. لم
          يكن أي مجموعة من Kanyes على أهدافه كاني
        </p>
        <hr />
      </div>
    ),
    footer: (
      <UncontrolledButtonDropdown group={false}>
        <DropdownToggle caret className="btn-round" color="info">
          <i className="now-ui-icons design_bullet-list-67" />
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem>عمل</DropdownItem>
          <DropdownItem>إجراء آخر</DropdownItem>
          <DropdownItem>شيء آخر هنا</DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    )
  }
];

// ##############################
// // // data for datatables.net in DataTables view
// #############################

const dataTable = {
  headerRow: ["Name", "Position", "Office", "Age", "Actions"],
  footerRow: ["Name", "Position", "Office", "Age", "Actions"],
  dataRows: [
    ["Tiger Nixon", "System Architect", "Edinburgh", "61"],
    ["Garrett Winters", "Accountant", "Tokyo", "63"],
    ["Ashton Cox", "Junior Technical Author", "San Francisco", "66"],
    ["Cedric Kelly", "Senior Javascript Developer", "Edinburgh", "22"],
    ["Airi Satou", "Accountant", "Tokyo", "33"],
    ["Brielle Williamson", "Integration Specialist", "New York", "61"],
    ["Herrod Chandler", "Sales Assistant", "San Francisco", "59"],
    ["Rhona Davidson", "Integration Specialist", "Tokyo", "55"],
    ["Colleen Hurst", "Javascript Developer", "San Francisco", "39"],
    ["Sonya Frost", "Software Engineer", "Edinburgh", "23"],
    ["Jena Gaines", "Office Manager", "London", "30"],
    ["Quinn Flynn", "Support Lead", "Edinburgh", "22"],
    ["Charde Marshall", "Regional Director", "San Francisco", "36"],
    ["Haley Kennedy", "Senior Marketing Designer", "London", "43"],
    ["Tatyana Fitzpatrick", "Regional Director", "London", "19"],
    ["Michael Silva", "Marketing Designer", "London", "66"],
    ["Paul Byrd", "Chief Financial Officer (CFO)", "New York", "64"],
    ["Gloria Little", "Systems Administrator", "New York", "59"],
    ["Bradley Greer", "Software Engineer", "London", "41"],
    ["Dai Rios", "Personnel Lead", "Edinburgh", "35"],
    ["Jenette Caldwell", "Development Lead", "New York", "30"],
    ["Yuri Berry", "Chief Marketing Officer (CMO)", "New York", "40"],
    ["Caesar Vance", "Pre-Sales Support", "New York", "21"],
    ["Doris Wilder", "Sales Assistant", "Sidney", "23"],
    ["Angelica Ramos", "Chief Executive Officer (CEO)", "London", "47"],
    ["Gavin Joyce", "Developer", "Edinburgh", "42"],
    ["Jennifer Chang", "Regional Director", "Singapore", "28"],
    ["Brenden Wagner", "Software Engineer", "San Francisco", "28"],
    ["Fiona Green", "Chief Operating Officer (COO)", "San Francisco", "48"],
    ["Shou Itou", "Regional Marketing", "Tokyo", "20"],
    ["Michelle House", "Integration Specialist", "Sidney", "37"],
    ["Suki Burks", "Developer", "London", "53"],
    ["Prescott Bartlett", "Technical Author", "London", "27"],
    ["Gavin Cortez", "Team Leader", "San Francisco", "22"],
    ["Martena Mccray", "Post-Sales support", "Edinburgh", "46"],
    ["Unity Butler", "Marketing Designer", "San Francisco", "47"],
    ["Howard Hatfield", "Office Manager", "San Francisco", "51"],
    ["Hope Fuentes", "Secretary", "San Francisco", "41"],
    ["Vivian Harrell", "Financial Controller", "San Francisco", "62"],
    ["Timothy Mooney", "Office Manager", "London", "37"],
    ["Jackson Bradshaw", "Director", "New York", "65"],
    ["Olivia Liang", "Support Engineer", "Singapore", "64"]
  ]
};

// ##############################
// // // data for populating the calendar in Calendar view
// #############################

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

const events = [
  {
    title: "All Day Event",
    allDay: true,
    start: new Date(y, m, 1),
    end: new Date(y, m, 1),
    color: "default"
  },
  {
    title: "Meeting",
    start: new Date(y, m, d - 1, 10, 30),
    end: new Date(y, m, d - 1, 11, 30),
    allDay: false,
    color: "green"
  },
  {
    title: "Lunch",
    start: new Date(y, m, d + 7, 12, 0),
    end: new Date(y, m, d + 7, 14, 0),
    allDay: false,
    color: "red"
  },
  {
    title: "Nud-pro Launch",
    start: new Date(y, m, d - 2),
    end: new Date(y, m, d - 2),
    allDay: true,
    color: "azure"
  },
  {
    title: "Birthday Party",
    start: new Date(y, m, d + 1, 19, 0),
    end: new Date(y, m, d + 1, 22, 30),
    allDay: false,
    color: "azure"
  },
  {
    title: "Click for Creative Tim",
    start: new Date(y, m, 21),
    end: new Date(y, m, 22),
    color: "orange"
  },
  {
    title: "Click for Google",
    start: new Date(y, m, 21),
    end: new Date(y, m, 22),
    color: "orange"
  }
];
const newEvents = [
  {
    id: "1",
    calendarId: 1,
    title: "All Day Event",
    category: "allday",
    dueDateClass: "",
    start: new Date(y, m, 1),
    end: new Date(y, m, 1)
  },
  {
    id: "2",
    calendarId: 1,
    title: "Meeting",
    start: new Date(y, m, d - 1, 10, 30),
    end: new Date(y, m, d - 1, 11, 30),
    category: "time",
    dueDateClass: ""
  },
  {
    id: "3",
    calendarId: 1,
    title: "Lunch",
    start: new Date(y, m, d + 7, 12, 0),
    end: new Date(y, m, d + 7, 14, 0),
    category: "time",
    dueDateClass: ""
  },
  {
    id: "4",
    calendarId: 1,
    title: "Nud-pro Launch",
    start: new Date(y, m, d - 2),
    end: new Date(y, m, d - 2),
    category: "allday",
    dueDateClass: ""
  },
  {
    id: "5",
    calendarId: 1,
    title: "Birthday Party",
    start: new Date(y, m, d + 1, 19, 0),
    end: new Date(y, m, d + 1, 22, 30),
    category: "time",
    dueDateClass: ""
  },
  {
    id: "6",
    calendarId: 2,
    title: "Click for Creative Tim",
    start: new Date(y, m, 21),
    end: new Date(y, m, 22),
    category: "time",
    dueDateClass: ""
  },
  {
    id: "7",
    calendarId: 2,
    title: "Click for Google",
    start: new Date(y, m, 21),
    end: new Date(y, m, 22),
    category: "time",
    dueDateClass: ""
  }
];
const calendars = [
  {
    id: "1",
    name: 'Private',
    bgColor: '#9e5fff',
    borderColor: '#9e5fff'
  },
  {
    id: "2",
    name: 'Company',
    bgColor: '#00a9ff',
    borderColor: '#00a9ff'
  }
];

// ##############################
// // // for vector map row in Dashboard view
// #############################

const us_flag = require("../assets/img/flags/US.png");
const de_flag = require("../assets/img/flags/DE.png");
const au_flag = require("../assets/img/flags/AU.png");
const gb_flag = require("../assets/img/flags/GB.png");
const ro_flag = require("../assets/img/flags/RO.png");
const br_flag = require("../assets/img/flags/BR.png");

const table_data = [
  { flag: us_flag, country: "USA", count: "2.920", percentage: "53.23%" },
  { flag: de_flag, country: "Germany", count: "1.300", percentage: "20.43%" },
  { flag: au_flag, country: "Australia", count: "760", percentage: "10.35%" },
  {
    flag: gb_flag,
    country: "United Kingdom",
    count: "690",
    percentage: "7.87%"
  },
  { flag: ro_flag, country: "Romania", count: "600", percentage: "5.94%" },
  { flag: br_flag, country: "Brasil", count: "550", percentage: "4.34%" }
];

// tasks list for Tasks card in Dashboard view
// data for <thead> of table in Tables view
// data for <tbody> of table in Tables view
// data for the timeline in Timeline view
// data for the timeline in Widgets view
// data for datatables.net in DataTables view
// data for populating the calendar in Calendar view
// data for populating the table from Dashboard view
export {
  tasks,
  tasksRTL,
  thead,
  theadhomevisits,
  theadcustomerscommunications,
  theadcontracts,
  theadcontracttemplates,
  theadcustomers,
  theadmobiles,
  theadmobilebonuses,
  theadmobileprocedures,
  theadsimdeliveriesmini,
  theadtickets,
  theadwebmobilerequests,
  theadwebmobilerequestsmini,
  tbody,
  stories,
  widgetStories,
  widgetStoriesRTL,
  dataTable,
  events,
  newEvents,
  calendars,
  table_data,
  usershead,
  usersbody,
  accessloghead,
  accesslogbody,
  logbody,
  loghead
};



// WEBPACK FOOTER //
// ./src/variables/general.jsx